import { AxiosInstance, AxiosResponse } from 'axios'
import client from './client'

export type WrappedResponse<T> = T & { $axios: AxiosResponse }

export default class AbstractResource {
  protected readonly client: AxiosInstance

  constructor () {
    this.client = client
  }

  protected wrapResponse<T> (response: AxiosResponse): WrappedResponse<T> {
    const data = typeof response.data === 'string' ? String(response.data) : response.data
    response.data = undefined
    data.$axios = response
    return data
  }
}
